import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { MultiViewPage } from "@/components/working/multi-view";

const searchSchema = z.object({
  // Tabs: one recipe at a time. Multi: all at once, as a grid or a spotlight.
  view: z.enum(["tabs", "multi"]).catch("multi"),
  layout: z.enum(["grid", "spotlight"]).catch("grid"),
});

export const Route = createFileRoute("/(protected)/_layout/multi-view")({
  validateSearch: (search) => searchSchema.parse(search),
  component: MultiViewRoute,
});

/** The recipes ticked on Prep, run together. The view and layout live in the address so a refresh keeps them. */
function MultiViewRoute() {
  const { view, layout } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <MultiViewPage
      view={view}
      layout={layout}
      onViewChange={(next) => navigate({ search: (prev) => ({ ...prev, view: next }), replace: true })}
      onLayoutChange={(next) => navigate({ search: (prev) => ({ ...prev, layout: next }), replace: true })}
    />
  );
}
